import moment from 'moment';

export function getNextFirstOrFifteenthAfter(initialDate: moment.Moment): moment.Moment {
	if (initialDate.date() === 1 || initialDate.date() === 15) {
		return initialDate;
	}

	if (initialDate.date() < 15) {
		let newDate = initialDate;
		newDate.date(15);
		return newDate;
	}
	let newDate = initialDate;
	newDate.date(1);
	newDate.month(initialDate.month() + 1);
	return newDate;
}

export function isToday(date: Date) {
	const today = moment();
	const giftDate = moment(date);
	return giftDate.isSame(today, 'day');
}

export function isAfterToday(date: Date) {
	const today = moment();
	const inputDate = moment(date);
	return inputDate.isAfter(today, 'day');
}
